"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.convoTags.name': 'Etiquetas de Conversación',
    'tools.convoTags.description': 'Agregar etiquetas relevantes a las conversaciones basadas en el contexto',
};
